import { stores } from "../redux/store";
import { setScreenParams } from "../redux/actions";

export const setSharedScreens = (screens = []) => {
  const sharedScreens = screens.filter(screen =>
    [
      "ConsultationPhotoModal",
      "AccountAuthorizedConsenterNew",
      "AccountAuthorizedConsenterEdit",
      "ConsultationBhRxModal",
      "PhotoModal",
      "ConsultationBhProviderProfile",
      "ConsultationSuccess",
      "ExpertMedicalOpinionCaseSuccessfullySubmitted",
      "PrimaryCareProviderSelectionSuccess",
      "MentalHealthNavigatorCaseSuccessfullySubmitted",
      "PersonalHealthNavigatorCaseSuccessfullySubmitted",
      "EliteDiagnosticImagingServiceCaseSuccessfullySubmitted",
      "PulseConsultationPhotoModal"
    ].includes(screen.name)
  );
  for (let i = 0; i < screens.length - 1; i++) {
    if ((screens[i].params || "").includes("TDScreenOptionSharedScreen")) {
      sharedScreens.push(screens[i]);
    }
  }

  stores.forEach(({ store }) => {
    store.dispatch(
      setScreenParams({
        sharedScreens
      })
    );
  });
};
